import { Component, computed, effect, inject, input, signal } from '@angular/core';
import { LocationsMapComponent } from '@locations';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { type WidgetMap } from '../../../models';
import { DashboardStore } from '../../../stores';

@Component({
  imports: [LocationsMapComponent, NgxSkeletonLoaderModule],
  selector: 'avs-map',
  styleUrl: './map.component.scss',
  templateUrl: './map.component.html',
})
export class MapComponent {
  config = input.required<WidgetMap>();

  protected location = computed(() => this.locationState());

  private store = inject(DashboardStore);
  private locationKey = signal('');
  private locationState = computed(() => this.store.locationInfo(this.locationKey())());

  constructor() {
    effect(() => {
      this.locationKey.set(this.store.loadLocationInfo(this.config().locationId));
    });
  }
}
